<template>
    <div>
        <div class="question">
            <footer-title>常见问题</footer-title>
            <ul class="leaseTable" v-for="item in question" :key="item.title">
                <li>
                    <h2>{{item.title}}</h2>
                </li>
                <li class="texts">
                    <div v-for="(hot,index) in item.content" :key="index">
                        <p v-if="hot.desc">{{hot.desc}}</p>
                        <p v-if="hot.boldText"><span style="color:#2c3e50;font-weight:bold">{{hot.boldText}}</span><span>{{hot.bold}}</span></p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import footerTitle from '_c/footerTitle.vue'
import {question} from './dataList.js'

export default {
    components: { footerTitle },
    data(){
        return{
            question
        }
    }

}
</script>

<style lang="scss" scoped>
.borderColor {
    color: #757272;
    font-size: 16px;
    tr {
        height: 30px;
        td {
            width: 135px;
        }
    }
}
.question {
    width: 917px;
    // width: 925px;
    padding-bottom: 70px;
    .leaseTable {
        margin: 10px;
        li {
            > div {
                font-size: 18px;
                color: #757272;
                margin: 15px 0;
            }
        }
        .texts {
            p {
                color: #757272;
                font-size: 18px;
                margin: 12px 0;
            }
        }
    }
    .leaseTable:last-child{
            padding-bottom: 100px;
        }
}
</style>